var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.units),function(unit,index){return _c('span',{key:`unit-${index}`},[_c('span',{staticClass:"tag hover",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$router.push(`/units/${unit.slug}`)}}},[_vm._v(_vm._s(unit.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }